import { createScope } from '~/lib/jotai'

export const scope = createScope('reservationInput.card')
